@if (data?.type === MediaType.Audio) {
	<audio #audioPlayer (timeupdate)="timeUpdateAudio($event)" hidden></audio>
}

<sim-basic-material-dialog
	(closeClicked)="
		close({
			uploadedFiles: uploadedFiles,
			action: 'ok',
		})
	"
	[finished]="finished"
	[matDialogData]="data"
	[overflowHandledByChild]="true"
	[rect]="rect"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-upload'}"
	[headerText]="T.UPLOAD_MEDIA_DIALOG_HEADER | translate"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<div class="changeMediaType">
			<span>
				@switch (data?.type) {
					@case (MediaType.Audio) {
						<mat-icon fontIcon="fa-volume-up" fontSet="fad" inline />
					}
					@case (MediaType.PDF) {
						<mat-icon fontIcon="fa-file-pdf" fontSet="fad" inline />
					}
					@case (MediaType.Excel) {
						<mat-icon fontIcon="fa-file-excel" fontSet="fad" inline />
					}
					@case (MediaType.Image) {
						<mat-icon fontIcon="fa-image-polaroid" fontSet="fad" inline />
					}
					@case (MediaType.PowerPoint) {
						<mat-icon fontIcon="fa-file-powerpoint" fontSet="fad" inline />
					}
					@case (MediaType.Video) {
						<mat-icon fontIcon="fa-file-video" fontSet="fad" inline />
					}
					@default {
						<mat-icon fontIcon="fa-file-edit" fontSet="fad" inline />
					}
				}
				{{ T.UPLOAD_MEDIA_DIALOG_TITLE | translate: {type: (mediaTypeKey | translate)} }}
			</span>
			<button (click)="data.type = undefined; setupForMediaType()" color="accent" mat-button>
				{{ T.UPLOAD_MEDIA_DIALOG_CHANGE_MEDIA_TYPE | translate }}
			</button>
		</div>
		<mat-divider />
		@if (data.type) {
			<input
				#uploadInput
				(change)="handleFileInput($event)"
				[accept]="acceptedFileTypes"
				id="upload"
				multiple
				style="display: none"
				type="file"
			/>
			@if (currentSelectedFiles && currentSelectedFiles?.length !== 0) {
				<div class="previewText">
					{{ T.ASSESSMENT_EDIT_PREVIEW | translate }}
				</div>
			}
			@if (currentSelectedFiles && currentSelectedFiles?.length !== 0) {
				<div class="previewFiles">
					<div class="filePreviewList">
						@for (currentSelectedFile of currentSelectedFiles; track currentSelectedFile; let i = $index) {
							<div [@anim]="'active'" class="previewFile">
								<sim-media-card-list
									(deleteButtonClicked)="deleteFromSelection(i)"
									(mediaClicked)="toggleMediaPlaying(currentSelectedFile, i)"
									(mediaNameChange)="currentSelectedFile.newName = $event"
									[active]="currentSelectedFile?.isPlaying"
									[currentSelectedFile]="currentSelectedFile"
									[isUploading]="currentSelectedFile.isUploading"
									[mediaName]="currentSelectedFile.name"
									[previewMediaType]="data?.type"
									[previewMediaUrl]="currentSelectedFile.mediaUrl"
									[previewMedia]="true"
									[progress]="currentSelectedFile?.progress"
									[showDeleteButton]="true"
									[uploadProgress]="currentSelectedFile.progressUploading"
								/>
							</div>
						}
					</div>
				</div>
			}
			<div class="uploadFilesFirst">
				<div class="uploadBtns">
					<button
						(click)="chooseFiles()"
						[color]="currentSelectedFiles && currentSelectedFiles.length !== 0 ? 'warn' : 'accent'"
						mat-raised-button
					>
						{{
							(currentSelectedFiles && currentSelectedFiles.length !== 0
								? T.UPLOAD_MEDIA_DIALOG_CLEAR_SELECTION
								: T.UPLOAD_MEDIA_DIALOG_CHOOSE_FILE
							) | translate
						}}
					</button>
					<button
						(click)="uploadFiles()"
						[disabled]="!currentSelectedFiles || currentSelectedFiles?.length === 0"
						color="accent"
						mat-raised-button
					>
						{{ T.UPLOAD_MEDIA_DIALOG_BUTTON | translate }}
					</button>
				</div>
				@if (afterViewInit && !currentSelectedFiles) {
					<div
						[@zoomInOnEnter]
						[@zoomOutOnLeave]
						[innerHTML]="(T.UPLOAD_MEDIA_DIALOG_HINT | translate: {type: mediaTypeKey | translate}) + acceptedFileTypes"
						class="uploadHint"
					></div>
				}
			</div>
		}

		@if (!data.type) {
			<div class="decideForMediaCon">
				<div (click)="mediaTypeSelected(mType)" *ngVar="MediaType.Audio as mType" class="mediaType" mat-ripple>
					<i class="mediaIcon fa fa-volume-up"></i>
					<div class="mediaText">
						{{ T.MEDIA_DIALOG_AUDIO | translate }}
					</div>
				</div>
				<div (click)="mediaTypeSelected(mType)" *ngVar="MediaType.PDF as mType" class="mediaType" mat-ripple>
					<i class="mediaIcon fa fa-file-pdf"></i>
					<div class="mediaText">
						{{ T.MEDIA_DIALOG_PDF | translate }}
					</div>
				</div>
				<div (click)="mediaTypeSelected(mType)" *ngVar="MediaType.Image as mType" class="mediaType" mat-ripple>
					<i class="mediaIcon fa fa-image-polaroid"></i>
					<div class="mediaText">
						{{ T.MEDIA_DIALOG_IMAGE | translate }}
					</div>
				</div>
				<div (click)="mediaTypeSelected(mType)" *ngVar="MediaType.PowerPoint as mType" class="mediaType" mat-ripple>
					<i class="mediaIcon fa fa-file-powerpoint"></i>
					<div class="mediaText">
						{{ T.MEDIA_DIALOG_POWERPOINT | translate }}
					</div>
				</div>
				<div (click)="mediaTypeSelected(mType)" *ngVar="MediaType.Video as mType" class="mediaType" mat-ripple>
					<i class="mediaIcon fa fa-file-video"></i>
					<div class="mediaText">
						{{ T.MEDIA_DIALOG_VIDEO | translate }}
					</div>
				</div>
			</div>
		}
	</ng-container>
</sim-basic-material-dialog>
